import { Record } from "immutable";
import { RecordUtils } from "@rsm-hcd/javascript-core";

interface InitializeGroupRecordData {
    name: string;
    emails: string[];
}

const defaultValues: InitializeGroupRecordData =
    RecordUtils.defaultValuesFactory<InitializeGroupRecordData>({
        name: "",
        emails: [],
    });

class InitializeGroupRecord
    extends Record(defaultValues)
    implements InitializeGroupRecordData
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: Partial<InitializeGroupRecordData>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<InitializeGroupRecordData>} values
     */
    public with(
        values: Partial<InitializeGroupRecordData>
    ): InitializeGroupRecord {
        return new InitializeGroupRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

export default InitializeGroupRecord;
